import bigImageSlider from './big_image_slider';
import twoColumnsImageSlider from './two_columns_image_slider';
import threeColumnsPostsSlider from './three_columns_posts_slider';
import fourColumnsClientsSlider from './four_columns_clients_slider';
import testimonialsSlider from './testimonials_slider';
import guitarsSlider from './guitars_slider';

const layouts = [
    bigImageSlider,
    twoColumnsImageSlider,
    threeColumnsPostsSlider,
    fourColumnsClientsSlider,
    testimonialsSlider,
    guitarsSlider,
]

export default layouts;